// import { resolve } from 'path'
import router from '@/router/premission'
import { sha256 } from 'js-sha256'
import { Base64 } from 'js-base64'
import {
  setToken
} from '@/utils/auth.js'
import {
  getLoginSalt,
  loginApi,
  getUserName,
  getMenus
} from '@/Api/login'
import config from '@/utils/config'
const login = {
  state: {
    username: '',
    breadcrumblist: [], // 面包屑集合
    menuList: [],
    tabs: [],
    activePath: ''
  },
  mutations: {
    SET_USERNAME(state, val) {
      state.username = val
    },
    SET_BREADCRUMBLIST(state, val) {
      state.breadcrumblist = [...state.breadcrumblist, val]
    },
    SET_MENULIST(state, val) {
      state.menuList = val
    },
    // 添加tab
    addTab(state, tab) {
      let flag = false
      state.tabs.forEach((item, index) => {
        if (item.path === tab.path) {
          flag = true
          // 如果路径相同，那么赋值新的参数
          state.tabs[index].query = tab.query
        }
      })
      if (!flag) {
        state.tabs.push(tab)
      }
      state.activePath = tab.path
      // sessionStorage.setItem('tabs', state.tabs)
    },
    setActiveTab: function (state, path) {
      state.activePath = path
      // sessionStorage.setItem('activePath', state.activePath)
    },
    setTab(state, arr) {
      state.tabs = arr
      sessionStorage.setItem('tabs', JSON.stringify(state.tabs))
    },
    // 移除tab
    removeTab(state, path) {
      let index = 0
      // 移除指定tab
      state.tabs = state.tabs.filter((item, inx) => {
        if (item.path === path) {
          index = inx
          return false
        } else {
          return true
        }
      })
      // 如果关闭的刚好是当前页则需要跳转到下一页
      if (path === state.activePath) {
        const next = state.tabs[index - 1]
        state.activePath = next.path
        router.push({ path: next.path, query: next.query })
      }
      sessionStorage.setItem('tabs', JSON.stringify(state.tabs))
      sessionStorage.setItem('activePath', state.activePath)
    },

  },
  actions: {
    // 获取用户信息 包括登录盐 登录token 用户信息
    async getUserNameAsync({ commit, getters }, { username, password }) {
      try {
        const saltRes = await getLoginSalt(username);
        console.log("username= ", username, ", saltRes= ", saltRes);
        if (!saltRes || saltRes.status !== 0 || !saltRes.data) {
          console.error('Failed to get login salt. saltRes= ', saltRes);
          return saltRes
        }
        const passcode = getters.calcPasscode(username, password, saltRes.data)
        const loginRes = await loginApi(username, passcode, saltRes.data.clientType);
        console.log("loginRes= ", loginRes);
        if (!loginRes || loginRes.status !== 0 || !loginRes.data) {
          console.error('Login failed. loginRes= ', loginRes);
          return loginRes
        }
        setToken(loginRes.data.token)
        // 获取用户信息 用户名等
        const userInfoRes = await getUserName(loginRes.data.token)
        console.log("userInfoRes= ", userInfoRes);
        if (!userInfoRes || userInfoRes.status !== 0 || !userInfoRes.data) {
          console.error('Failed to get user info. userInfoRes= ', userInfoRes);
          return userInfoRes
        }
        sessionStorage.setItem('username', userInfoRes.data.username)
        localStorage.setItem('username', userInfoRes.data.username)
        commit('SET_USERNAME', userInfoRes.data.username)

        return userInfoRes

      } catch (err) {
        console.error('Login salt fetch failed:', err);
      }
    },

    // 获取菜单权限
    getmenusAsync({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getMenus(config.sysid).then(res => {
          if (res.status == 0) {
            if (!res.data) res.data = []
            resolve(res.data)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

  },
  getters: {
    calcPasscode: (state) => (username, password, loginSalt) => {
      console.log("username= ", username)
      const v = new Uint8Array(sha256.array(loginSalt.code + password))
      // console.log(v)
      const hashA = Base64.fromUint8Array(v)
      console.log(hashA)
      const str = username + ":" + hashA + ":" + loginSalt.salt
      const passcode = Base64.fromUint8Array(new Uint8Array(sha256.array(str)))
      console.log("str= ", str, " passcode= ", passcode)
      return passcode
    },
  }
}

export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js